import { useState } from "react";
import { Grid, InputAdornment, TextField, Tooltip } from "@mui/material";
import SelectField from "../../../../SelectField/SelectField";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import TextFieldCount from "@/components/Form/TextFieldCount/TextFieldCount";
import * as actions from "../../../../MainWebsiteComponent/store/actions";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Settings.module.css";
import axios from "axios";
import { Poppins } from "next/font/google";

const PoppinsFont = Poppins({
  weight: ["300", "400", "500", "600", "700", "900"],
  subsets: ["latin"],
  display: "swap",
});

const Settings = ({ checkingSubDomainError, setCheckingSubDomainError, available, setAvailable }) => {
  const baseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;
  const dispatch = useDispatch();

  const [onlineTeachingState, setOnlineTeachingState] = useState(
    useSelector((state) => state.alreadyTeachingOnline)
  );
  const [studentCSV, setStudentCSV] = useState(
    useSelector((state) => state.studentsCSV)
  );
  
  const [teachingPageUrl, setTeachingPageUrl] = useState(
    useSelector((state) => state.dba.toLowerCase().split(" ").join("-"))
  );

  let error = useSelector((state) => state.error);
  const checkingSubDomain = (data) => {
    if (data) {
      axios
        .get(`${baseUrl}/checkExistingSubDomain?searchText=${data}`)
        .then((response) => {
          // console.log(response, 345);
          if (response.data.subDomain) {
            setCheckingSubDomainError(true);
            setAvailable(false);
          } else {
            setCheckingSubDomainError(false);
            setAvailable(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const validateURL = (url) => {
    const regex = /^[a-zA-Z0-9-_]{4,40}$/;  // Allow only letters, numbers, hyphen, and underscore, with length between 4 and 40
    return regex.test(url);  // Returns true if the URL is valid, false otherwise
  }

  const handleChanges = (fieldName) => (event) => {
    const value = event.target.value;
    console.log(value);
    if (fieldName == "teachingPageUrl") {
      if(validateURL(value)){
        checkingSubDomain(value);
        dispatch(actions.setTeachingPageUrl(value));
        setTeachingPageUrl(value);
      }
    } else if (fieldName == "onlineTeachingState") {
      dispatch(actions.setAlreadyTeachingOnline(value));
      setOnlineTeachingState(value);
    } else if (fieldName == "studentCSV") {
      dispatch(actions.setStudentsCSV(value));
      setStudentCSV(value);
    }
    const newErrors = { ...error };
    newErrors[fieldName] = false;
    dispatch(actions.setError(newErrors));
  };

  const options = [
    {
      label: "Yes",
      value: "Yes",
    },

    {
      label: "No",
      value: "No",
    },
  ];

  return (
    <div className="StepperContentSection">
      <div className={styles.MdTitle}>Settings</div>
    <Grid container spacing={2} sx={{ fontFamily: PoppinsFont.style }}>
      <Grid item xs={12}>
        <div className={styles.FieldLabelContainer}>
          <div className={styles.FieldLabel}>
            <span style={{ color: "#676C7B" }}>
              Your own teaching account page URL
              <span style={{ color: "#D32E2F" }}>*</span>
            </span>
            &nbsp;
            <Tooltip
              title="Make sure your domain is unique, short, and easy to remember. All character should be all lower case, and no special character."
              placement="top"
              arrow
            >
              <InfoOutlinedIcon sx={{ opacity: "30%" }} fontSize="small" />
            </Tooltip>
          </div>
          {error.teachingPageUrl && (
            <div className={styles.requiredTxt}>Required</div>
          )}
        </div>
        <TextField
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              padding: "0px !important",
            },
            "& .MuiFormHelperText-root": {
              marginLeft: "0px",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                className={styles.inputAdornmentEnd}
              >
                https://mytakbir.com/t/
              </InputAdornment>
            ),
          }}
          variant="outlined"
          required={error.teachingPageUrl ? true : false}
          value={teachingPageUrl}
          onChange={handleChanges("teachingPageUrl")}
          error={error.teachingPageUrl || checkingSubDomainError}
          helperText={
            checkingSubDomainError ? (
              <p
                className={styles.notAvailable}
                style={{ fontFamily: PoppinsFont.style.fontFamily }}
              >
                <CancelRoundedIcon fontSize="small" />
                <span>Not available</span>
              </p>
            ) : available ? (
              <p
                className={styles.available}
                style={{ fontFamily: PoppinsFont.style.fontFamily }}
              >
                <CheckCircleRoundedIcon fontSize="small" />
                <span>Available</span>
              </p>
            ) : (
              ""
            )
          }
          // helperText={
          //   <p className={styles.notAvailable}>
          //     <CancelRoundedIcon fontSize="small" />
          //     <span>Not available</span>
          //   </p>
          // }
        />
      </Grid>

      <Grid item xs={12}>
        <SelectField
          label="Are you currently teaching or have you taught any online courses before?"
          options={options}
          selectedOption={onlineTeachingState}
          handleChange={handleChanges("onlineTeachingState")}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectField
          label="Do you have existing students or learner contacts to invite?"
          options={options}
          selectedOption={studentCSV}
          handleChange={handleChanges("studentCSV")}
        />
      </Grid>
    </Grid>
    </div>
  );
};

export default Settings;
